import React from 'react';
import {Button, Modal} from 'react-bootstrap';
import {FaClock} from 'react-icons/fa';
import {useTranslation} from 'react-i18next';

const SkyworkPastSlotModal = ({show, onHide}) => {
  const {t} = useTranslation();

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="skywork-booking-confirm-dialog"
      className="skywork-booking-confirm-modal skywork-past-slot-modal"
      centered
    >
      <Modal.Header closeButton>
        <div className="skywork-booking-confirm-heading">
          <span><FaClock aria-hidden="true"/></span>
          <div>
            <small>{t('BOOKING_SLOT_DETAILS')}</small>
            <Modal.Title>{t('BOOKINGS')}</Modal.Title>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p className="skywork-past-slot-message">{t('BOOKING_EVENT_HAS_PASSED')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" className="skywork-primary-action" onClick={onHide}>{t('OK')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SkyworkPastSlotModal;
